const createAddressProviderApi = ({ addressProvider, }) => {
    const getReceiveAddress = async (opts) => {
        const address = await addressProvider.getReceiveAddress(opts);
        return address?.address;
    };
    return {
        addressProvider: { getReceiveAddress },
    };
};
const addressProviderDefinition = {
    id: 'addressProviderApi',
    type: 'api',
    factory: createAddressProviderApi,
    dependencies: ['addressProvider'],
};
export default addressProviderDefinition;
